var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-modal__hd"},[_c('strong',{staticClass:"normal-modal__title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }